import { ReactNode } from 'react';
import { TFunction } from 'i18next';

import { formatDayAndTime } from 'support/helpers/dateTime/dateTime';
import { MessageV2DTO } from 'support/types';
import { Translate } from 'components/Translate/Translate';

type DroppedErrorReason = MessageV2DTO['dropped_error_reasons'][number];

type FormattedDroppedReason = {
  displayMode: 'formatted' | 'fallback';
  header: string | null;
  content: ReactNode;
  howToFix?: string | null;
};

export const formatDroppedReason = (reason: DroppedErrorReason, t: TFunction): FormattedDroppedReason => {
  const isInternal = !!reason.dropped_by?.isAdmin;
  const userName = reason.dropped_by?.name;
  const partnerName = reason.dropped_by?.partner?.name;
  const droppedAt = reason.dropped_at;
  const reasonText = reason.reason || '';

  if (isInternal && droppedAt) {
    const formattedDate = formatDayAndTime(droppedAt);
    return {
      displayMode: 'formatted',
      header: null,
      content: (
        <Translate
          i18nKey="transactions:show.sections.errors.alert.droppedByProcuros"
          values={{
            date: formattedDate,
            reason: reasonText,
          }}
        />
      ),
      howToFix: null,
    };
  }

  if (!isInternal && userName && partnerName && droppedAt) {
    const formattedDate = formatDayAndTime(droppedAt);
    return {
      displayMode: 'formatted',
      header: null,
      content: (
        <Translate
          i18nKey="transactions:show.sections.errors.alert.droppedByUser"
          values={{
            userName,
            partnerName,
            date: formattedDate,
            reason: reasonText,
          }}
        />
      ),
      howToFix: null,
    };
  }

  return {
    displayMode: 'fallback',
    header: reason.title || t('transactions:show.sections.errors.alert.messageDropped'),
    content: reason.description || reasonText,
    howToFix: reason.howToFix || null,
  };
};
